import React from "react";

const SAMPLE_WIDTH = 649;
const SAMPLE_HEIGHT = 482;

const EventHalfPitchBaseLayer = ({ fieldWidth, fieldHeight, fieldPadding = 0 }) => {
  const scaleX = fieldWidth / SAMPLE_WIDTH;
  const scaleY = fieldHeight / SAMPLE_HEIGHT;
  const scale = Math.min(scaleX, scaleY);

  const px = (value) => fieldPadding + value * scaleX;
  const py = (value) => fieldPadding + value * scaleY;
  const sw = (value) => value * scaleX;
  const sh = (value) => value * scaleY;
  const sr = (value) => value * scale;

  const inset = 1;
  const halfLineY = 438;
  const centerX = SAMPLE_WIDTH / 2;

  return (
    <g>
      <rect
        className="pitch-line"
        x={px(inset)}
        y={py(inset)}
        width={sw(SAMPLE_WIDTH - inset * 2)}
        height={sh(SAMPLE_HEIGHT - inset * 2)}
      />
      <line
        className="pitch-line"
        x1={px(inset)}
        y1={py(halfLineY)}
        x2={px(SAMPLE_WIDTH - inset)}
        y2={py(halfLineY)}
      />
      <circle className="pitch-line" cx={px(centerX)} cy={py(halfLineY)} r={sr(84)} />
      <circle className="pitch-spot" cx={px(centerX)} cy={py(halfLineY)} r={Math.max(1.5, sr(3))} />

      <rect className="pitch-line" x={px(136)} y={py(inset)} width={sw(377)} height={sh(146)} />
      <rect className="pitch-line" x={px(237)} y={py(inset)} width={sw(175)} height={sh(52)} />
      <rect className="pitch-line" x={px(287)} y={py(inset)} width={sw(75)} height={sh(20)} />
      <circle className="pitch-spot" cx={px(centerX)} cy={py(100)} r={Math.max(1.5, sr(3))} />
      <path
        className="pitch-line"
        d={`M ${px(253)} ${py(146)} A ${sr(72)} ${sr(72)} 0 0 0 ${px(396)} ${py(146)}`}
      />
    </g>
  );
};

export default EventHalfPitchBaseLayer;
